(function () {
    'use strict';
    angular.module('app').controller('RoutePlanningModalController', RoutePlanningModalController);
    RoutePlanningModalController.$inject = [
        'jobs',
        'id',
        '$timeout',
        '$uibModalInstance',
        'FleetService',
        'toastr',
        '$uibModal'
    ];
    function RoutePlanningModalController(
        jobs,
        id,
        $timeout,
        $uibModalInstance,
        FleetService,
        toastr,
        $uibModal
    ) {
        const vm = this;
        let googleMapInstance;
        let markers = [];
        let hoverTimeout;

        vm.onSearchJob = onSearchJob;
        vm.onSelectJob = onSelectJob;
        vm.onSearchDriver = onSearchDriver;
        vm.onSelectDriver = onSelectDriver;
        vm.onDropComplete = onDropComplete;
        vm.saveRun = saveRun;
        vm.onRemoveJob = onRemoveJob;
        vm.onEditDriverAddress = onEditDriverAddress;
        vm.cancel = cancel;
        vm.isDriverAddressLastMileChange = isDriverAddressLastMileChange;

        init();

        function init() {
            if (id) {
                initEditRunData(id);
                return;
            }

            initCreateRunData();
        }

        function initEditRunData(id) {
            FleetService.RoutePlanning.getRunDetails(data => {
                const { latitude, longitude } = data.stops[0];
                initMap({ lat: latitude, lng: longitude });

                vm.selectedDriver = {
                    id: data.driverId,
                    firstName: data.driverFirstName,
                    lastName: data.driverLastName
                }

                vm.jobs = data.stops.map(job => {
                    return {
                        id: job.id,
                        jobId: job.jobNumber,
                        formattedDestinationAddress: `${job.addressLine1} ${job.addressLine2} ${job.cityOrSuburb} ${job.postcode}`,
                        locationData: {
                            lat: job.latitude,
                            lng: job.longitude
                        }
                    };
                });
                initMarkers();
            }, error => {
                toastr.error(error.message, 'Error');
            }, id);
        }

        function initCreateRunData() {
            vm.jobs = [];
            for (let i = 0; i < jobs.length; i++) {
                const job = jobs[i];
                const addressData = i == 0 ? job.sourceAddress : job.destinationAddress;

                vm.jobs.push({
                    id: job.id,
                    jobId: job.jobId,
                    formattedDestinationAddress: parseAddress(addressData),
                    locationData: {
                        lat: addressData.location.latitude,
                        lng: addressData.location.longitude
                    }
                });
            }

            $timeout(() => {
                const latitude = vm.jobs[0].locationData.lat;
                const longitude = vm.jobs[0].locationData.lng;
                initMap({ lat: latitude, lng: longitude });
                initMarkers();
            }, 1000);
        }

        function initMap(coordinates) {
            const { lat, lng } = coordinates;
            googleMapInstance = new google.maps.Map(document.getElementById('map'), {
                center: {
                    lat: parseFloat(lat),
                    lng: parseFloat(lng)
                },
                zoom: 10,
                disableDefaultUI: true,
                zoomControl: false,
            });
        }

        function initMarkers() {
            markers = [];
            vm.jobs.forEach((item, index) => {
                const customMarker = index === 0;
                addMarker(index, item, customMarker);
            });
        }

        function addMarker(index, jobData, startLocation = false, endLocation = false) {
            const { locationData } = jobData;
            const iconColor = getMarkerIconColor(startLocation, endLocation);
            const marker = new google.maps.Marker({
                position: { lat: locationData.lat, lng: locationData.lng },
                map: googleMapInstance,
                label: `${index + 1}`,
                title: `${jobData.jobId}`,
                icon: {
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 10,
                    fillColor: iconColor.fillColor,
                    fillOpacity: 1,
                    strokeColor: iconColor.strokeColor,
                    strokeWeight: 3
                }
            });
            const infoWindow = new google.maps.InfoWindow({
                content: `
                <div style="max-width: 200px;" id="content">
                    <div id="siteNotice"></div>
                    <h5 id="firstHeading" class="firstHeading">${jobData.jobId || jobData.driverName}</h5>
                    <div id="bodyContent">${jobData.formattedDestinationAddress}</div>
                </div>
                `
            });

            marker.addListener('mouseover', () => {
                hoverTimeout = setTimeout(() => {
                    infoWindow.open(map, marker);
                }, 200);

            });
            marker.addListener('mouseout', () => {
                clearTimeout(hoverTimeout);
                infoWindow.close();
            });

            markers.splice(index, 0, marker);
            fitMapToMarkers();
        }

        function getMarkerIconColor(startLocation, endLocation) {
            if (startLocation) {
                return {
                    fillColor: '#77ef2cff',
                    strokeColor: '#4BB807'
                }
            }

            if (endLocation) {
                return {
                    fillColor: '#e53c42ff',
                    strokeColor: '#a50f14ff'
                }
            }

            return {
                fillColor: '#5bc0de',
                strokeColor: '#2574ab'
            }
        }

        function fitMapToMarkers() {
            if (markers.length === 0) return;
            const bounds = new google.maps.LatLngBounds();
            markers.forEach(marker => bounds.extend(marker.getPosition()));
            googleMapInstance.fitBounds(bounds);
        }

        function onSearchJob(searchTerm) {
            FleetService.RoutePlanning.getRoutePlanningAvailableJobs(data => {
                if (!vm.jobs) { return; }
                const selectedIds = new Set(vm.jobs.map(item => item.jobId));
                vm.foundJobs = data.content.filter(item => !selectedIds.has(item.jobId));
            }, error => {
                toastr.error(error.message, 'Error');
            }, { consignmentId: searchTerm });
        }

        function onSelectJob(job) {
            const jobData = {
                id: job.id,
                jobId: job.jobId,
                formattedDestinationAddress: parseAddress(job.destinationAddress),
                locationData: {
                    lat: job.destinationAddress.location.latitude,
                    lng: job.destinationAddress.location.longitude
                }
            };

            vm.jobs.splice(vm.jobs.length - 2, 0, jobData);
            addMarker(vm.jobs.length - 2, jobData); // todo: need to make this working here...
        }

        function parseAddress(address, isNameIncluded = true) {
            const { firstName, lastName, addressLine1, addressLine2, location } = address;
            const { country, state, name, code } = location;

            if (isNameIncluded) {
                return `${firstName} ${lastName} ${addressLine1} ${addressLine2 || ''} ${name} ${state ? state.name : ''} ${code} ${country.code}`;
            }

            return `${addressLine1} ${addressLine2 || ''} ${name} ${state ? state.name : ''} ${code} ${country.code}`;
        }

        function onDropComplete(dragIndex, dropIndex) {
            const dragData = vm.jobs[dragIndex];
            vm.jobs.splice(dragIndex, 1);
            vm.jobs.splice(dropIndex, 0, dragData);
            initMarkers();
        }

        function onRemoveJob(index) {
            if (vm.jobs.length < 2) {
                vm.jobs = []; // clear all jobs
                markers.forEach(marker => { marker.setMap(null); });
                markers = [];
                return;
            }

            vm.jobs.splice(index, 1);
            markers.forEach((marker, markerIndex) => {
                if (markerIndex === index) { marker.setMap(null); }
            });
            markers.splice(index, 1);
            fitMapToMarkers();
        }

        function onSearchDriver(searchTerm) {
            FleetService.Drivers.getAll(data => {
                vm.drivers = data.content;
            }, error => {
                toastr.error(error.message, 'Error');
            }, { name: searchTerm });
        }

        function onSelectDriver() {
            if (!vm.isDriverAddressLastMile) { return; } 
            removeDriverAddressAsLastMile();
            addDriverAddressAsLastMile();
        }

        function isDriverAddressLastMileChange() {
            const checked = !vm.isDriverAddressLastMile;
            if (checked) {
                addDriverAddressAsLastMile();
                return;
            }

           removeDriverAddressAsLastMile();
        }

        function removeDriverAddressAsLastMile() {
            const lastItemIndex = vm.jobs.length - 1;
            onRemoveJob(lastItemIndex);
        }

        function addDriverAddressAsLastMile() {
            const driverData = {
                driverName: `${vm.selectedDriver.firstName} ${vm.selectedDriver.lastName}`,
                formattedDestinationAddress: parseAddress(vm.selectedDriver, false),
                locationData: {
                    lat: vm.selectedDriver.latitude,
                    lng: vm.selectedDriver.longitude
                }
            };
            vm.jobs.push(driverData);
            addMarker(vm.jobs.length - 1, driverData, false, true);
        }

        function saveRun() {
            if (!vm.selectedDriver) {
                console.log('Please select a driver');
                return;
            }

            const payload = createPayload();
            FleetService.RoutePlanning.saveRun(data => {
                toastr.success('Run successfully saved!', 'Success!');
                $uibModalInstance.close(data);
            }, error => {
                toastr.error(error.message, 'Error');
            }, payload);
        }

        function createPayload() {
            return {
                driverAddress: {
                    addressLine1: vm.selectedDriver.addressLine1,
                    addressLine2: vm.selectedDriver.addressLine2,
                    locationId: vm.selectedDriver.location.id
                },
                driverId: vm.selectedDriver.id,
                jobIds: vm.jobs.filter(job => job.id).map(job => job.id)
            }
        }

        function onEditDriverAddress() {
            $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: '/templates/pages/route-planning/modal/rp-edit-driver-address.modal.html',
                controller: 'RPEditDriverAddressModalController',
                controllerAs: 'vm',
                size: 'md',
                appendTo: $('body'),
                resolve: {
                    driverData: () => vm.selectedDriver
                }
            }).result.then(data => {
                if (!data) { return; }
                vm.selectedDriver = data;
            });
        }

        function cancel() {
            $uibModalInstance.close();
        }
    }
})()


// WEBPACK FOOTER //
// ./js/controllers/route-planning/modal/RoutePlanningModalController.js